import React, { useMemo } from 'react';
import { Box, Flex } from '@chakra-ui/react';

import { useTranslations } from '../../../../contexts/LocalizationContext';
import { useScannedRelevosContext } from '../../../../contexts/ScannedRelevosContext';
import RelevoScanner from '../../common/components/RelevoScanner';
import RelevosSteps from '../../common/components/RelevosSteps/RelevosSteps';
import ReturnSumUp from '../SumUp/ReturnSumUp';
import { ItemAssignmentSelectMode, UserSelectMode } from '../UserSelect/types';

export const ScanReturn = () => {
  const translations = useTranslations();
  const { selectItemMode } = useScannedRelevosContext();

  const secondStepDescription = useMemo(() => {
    switch (selectItemMode) {
      case ItemAssignmentSelectMode.CAMERA_SCAN:
        return translations('relevos_step_2_description');
      case ItemAssignmentSelectMode.HAND_SCANNER_SCAN:
        return translations('relevos_step_2_hand_scanner_description');
      default:
        return undefined;
    }
  }, [selectItemMode, translations]);

  return (
    <Box>
      <Flex bgColor={'beige.50'} width="100%" wrap="wrap" px={3} minH={'350px'}>
        <Box height="100%" py={4} width={['100%', '100%', '100%', '100%', '50%']}>
          <RelevosSteps
            firstStep={translations('relevos_step_1')}
            firstStepDescription={translations('relevos_return_step_1_description')}
            secondStep={translations('relevos_step_2')}
            secondStepDescription={secondStepDescription}
            isUpgrade={false}
            mode={UserSelectMode.ASSIGNMENT}
          />
        </Box>

        <Flex wrap="wrap" width={['100%', '100%', '100%', '100%', '45%']}>
          <RelevoScanner />
        </Flex>
      </Flex>
      <Box width={['100%', '100%', '100%', '55%']}>
        <ReturnSumUp />
      </Box>
    </Box>
  );
};
